import React, { useEffect, useState } from "react";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import Page from "../../helpers/config";
import { useSelector } from "react-redux";
// import { message } from "../../redux/actions/toastActions";
import DeleteModal from "../../components/common/DeleteModal";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import leftArrow from "../../assets/Icons/leftArrow.svg";

const Faqs_List = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [Data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [refresh, setRefresh] = useState(true);
  const [perPage, setperPage] = useState(Page.records);
  const [currentPage, setcurrentPage] = useState(1);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  console.log("permissions", permissions);
  const isAccessible =
    role === "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("view_Admissions") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Admissions") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Admissions") || permissions?.includes("delete_School"))) ||
    false;
  const mode = localStorage.getItem("mode")
  const schoolId = localStorage.getItem("activeSchoolId");
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const feeStructureData = () => {
    setIsloading(true);
    Postdata(HttpService.admission_faqs_list, {
      page: currentPage,
      perpage: perPage,
      //   board_member_id: boardMemberId,
      //   startDate: startDate,
      //   endDate: endDate,
      school_id: schoolId,
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response.data.faqs);
          setTotalRows(response.data.count);
          setIsloading(false);
        } else {
          setIsloading(false);
          // dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        // dispatch(message(e.message));
      });
  };

  useEffect(() => {
    feeStructureData();
  }, [refresh]);

  const handleDelete = (id) => {
    if (!id) return;

    setmodalOpenDelete(false);
    setIsloading(true);

    Postdata(HttpService.admission_faqs_delete, { id })
      .then((res) => {
        // dispatch(message(res.message));
        toast.success(res.message);
        setRefresh((prev) => !prev);
        setOpenMenuIndex(null);
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        // dispatch(message("Failed to delete. Please try again."));
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleNavigation = () => {
    if (mode === "view") {
      navigate(`admin-school/view/${schoolId}`, {
        state: { mainTab: "Admissions" },
      });
    } else if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
      navigate("navigation-dashboard", {
        state: { mainTab: "Admissions" },
      });
    } else {
      navigate("admissions");
    }
  };

  if (!isAccessible) {
    <Error403Page />;
  }
  return (
    <>
      <Title name="Admissions FAQs" />
      <div className="flex items-center gap-1 py-4 px-6">
        <img
          src={leftArrow}
          alt="back"
          className="cursor-pointer"
          onClick={handleNavigation}
        />
      </div>
      <Topbar
        title="FAQs"
        // aerrow={true}
        btn={addPermission}
        btnName="+Add"
        btnLink="admissions/faqs/add"
      />
      <div className="p-6 space-y-6 pr-0">
        {isLoading ? (
          <div className="text-center text-gray-500">Loading...</div>
        ) : (
          Data?.map((subject, index) => (
            <div
              key={index}
              className="relative bg-white p-[15px] rounded-xl hover:shadow-lg transition"
            >
              {/* Three Dots Menu */}
              {(addPermission || deletePermission) && (
                <div className="absolute top-3 right-3">
                  <button onClick={() => toggleMenu(index)}>
                    <img
                      src={HiOutlineDotsVertical}
                      className="text-gray-500 hover:text-black"
                    />
                  </button>

                  {openMenuIndex === index && (
                    <div className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                      {addPermission && (
                        <button
                          className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                          onClick={() =>
                            navigate(`admissions/faqs/edit/${subject._id}`, {
                              state: { mode: "Edit", id: subject._id },
                            })
                          }
                        >
                          Edit
                        </button>
                      )}
                      {deletePermission && (
                        <button
                          className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                          onClick={() => {
                            setmodalOpenDelete(true);
                            setSelectedId(subject._id);
                          }}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Title & Description */}
              <div className="mb-1">
                <h3 className="label-body-base flex gap-2">
                  {subject.question}
                </h3>
                <p className="mt-1 text-card-body mb-0">
                  {subject.description}
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      <DeleteModal
        title="Delete FAQ"
        message="Are you sure you want to delete FAQ ?
         It will erase all the data permanently."
        modalOpenDelete={modalOpenDelete}
        setmodalOpenDelete={setmodalOpenDelete}
        handleDelete={handleDelete} // Don't call it here
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        module="FAQ"
        redirectPage="Admissions"
        redirectUrl="admissions/faqs"
        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
      />
      {!isLoading && Data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Faqs_List;
